// Third-party
import React from 'react';

// Components
import { FormattedMessage } from '../../../../../utils/i18n';
import { SecondaryButton } from '../../../../../views/components/buttons';
import { Typography } from '@capintel/component-lib/typography';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  onEditBrandingInfo?: () => void;
};

const EditProposalAdvisorInfo: React.FunctionComponent<Props> = ({ onEditBrandingInfo, ...rest }: Props) => (
  <div className="proposal-option">
    <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
      <FormattedMessage id="Proposal.Tabs.Options.AdvisorInfoForm" />
    </Typography>
    <SecondaryButton className="reselect-template" compact onClick={onEditBrandingInfo}>
      <FormattedMessage id="Proposal.Tabs.Options.EditAdvisorInfo" />
    </SecondaryButton>
  </div>
);

export default EditProposalAdvisorInfo;
